module.exports = __webpack_public_path__ + "img/savanah_content_img_03.904bfddb.jpg";